import templateUrl from './service-area.html';
import find from 'lodash/find';
import head from 'lodash/head';
import size from 'lodash/size';

export const serviceAreaListComponent = {
    bindings: {
        details: '<'
    },

    templateUrl,

    controller: class ServiceAreaListComponent {
        constructor($anchorScroll, $state, ServiceAreaCountyService, ModalService, toastr) {
            'ngInject';

            this.$anchorScroll = $anchorScroll;
            this.$state = $state;
            this.serviceAreaCountyService = ServiceAreaCountyService;
            this.modalService = ModalService;
            this.toastr = toastr;
        }

        $onInit() {
            this.pageTitle = 'Service Area';
            this.serviceAreaList = this.serviceAreaCountyService.getServiceAreaList(this.details.data.content);
            if (this.serviceAreaList.length > 0) {
                //By default tab is selected as County
                this.serviceAreaList[0].isSelected = true;
            }
            this.selectedServiceAreas = this._getSelectedServiceAreaList();
            this.totalItems = head(this.serviceAreaList).count;
            this._resetPaginationConfigObject();
        }

        onChange(pageNumber) {
            this.currentPage = pageNumber;
            this._setFilterObject();
            this._getFilteredServiceAreaList()
                .then(list => {
                    this.selectedServiceAreas = angular.copy(list);
                });
        }

        onServiceAreaAdd() {
            this._openServiceAreaAddModal();
        }

        onChangeAreaType(areaType) {
            this._changeSelectedServiceAreaType(areaType)
            this._setSelectedAreaList();
            this._resetPaginationConfigObject();
        }

        displayProvidersList(serviceAreaId, providersLinked) {
            if(providersLinked > 0) {
                this._openProvidersListModal(serviceAreaId);
            }
        }

        onDeleteServiceArea({ serviceAreaId, providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked }) {
            const warningMessage = this._getWarningMessageForDeleteAction(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked);
            this.modalService.open({
                details: {
                    bodyMessage: `${warningMessage}`
                },
                buttons: [{
                    name: 'No'
                }, {
                    name: 'Yes',
                    isPrimary: true,
                    action: _onDelete.bind(this, serviceAreaId)
                }]
            });

            function _onDelete(serviceAreaId) {
                this.serviceAreaCountyService.deleteServiceArea(serviceAreaId)
                    .then(_ => {
                        this.toastr.success("service area deleted successfully");
                        this.$state.reload();
                    })
                    .catch(err => {
                        this.toastr.error(err);
                    });
            }
        }

        //*******************************************************Private Methods************************************ */

        _getWarningMessageForDeleteAction(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
            if(this._isServiceAreaNotLinkedToAnyModule(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked)) {
                return `Action can not be reverted back, Are you sure you want to delete it?`;
            } else {
                const message = this._getWarningMessageWithAffectedModuleDetails(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked);

                return message;
            }
        }

        _isServiceAreaNotLinkedToAnyModule(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
            return (providersLinked === 0 && bicycleAndPedestrianLinked === 0 && mobilityManagerLinked === 0 && progressReportLinked === 0 && ridesharingLinked === 0);
        }

        _getWarningMessageWithAffectedModuleDetails(providersLinked, bicycleAndPedestrianLinked, mobilityManagerLinked, progressReportLinked, ridesharingLinked) {
            let warningMessage = [];

            if(providersLinked > 0) {
                warningMessage = [`${providersLinked} Transportation provider(s)`,...warningMessage];
            }

            if(bicycleAndPedestrianLinked > 0) {
                warningMessage = [`${bicycleAndPedestrianLinked} Bicycle And Pedestrian`,...warningMessage];
            }

            if(mobilityManagerLinked > 0) {
                warningMessage = [`${mobilityManagerLinked} Mobility Manager(s)`,...warningMessage];
            }

            if(progressReportLinked > 0) {
                warningMessage = [`${progressReportLinked} Progress Report(s)`,...warningMessage];
            }

            if(ridesharingLinked > 0) {
                warningMessage = [`${ridesharingLinked} Ridesharing`,...warningMessage];
            }

            return `${warningMessage.join(', ')} have been linked to this service area. Action can not be reverted back. Are you sure you want to delete this service area?`;
        }

        _getSelectedServiceAreaList() {
            const { values } = this._getSelectedServiceAreaTypeObject();
            return values;
        }

        _setFilterObject() {
            this.filterDetails.limit = this.itemPerPage;
            this.filterDetails.pageId = this.currentPage;
        }

        _openServiceAreaAddModal() {
            this.modalService.open({
                backdrop: 'static',
                keyboard: false,
                component: 'serviceAreaAdd',
                details: {
                    reloadCountyList: () => {
                        this.$state.reload();
                    }
                }
            });
        }

        _openProvidersListModal(serviceAreaId) {
            this.modalService.open({
                backdrop: 'static',
                keyboard: false,
                component: 'serviceAreaProvidersList',
                details: {
                    serviceAreaId
                }
            });
        }

        _changeSelectedServiceAreaType(areaType) {
            const newSelectedAreaType = find(this.serviceAreaList, { serviceAreaType: areaType });
            const selectedAreaType = this._getSelectedServiceAreaTypeObject();

            selectedAreaType.isSelected = false;
            newSelectedAreaType.isSelected = true;
        }

        _getSelectedServiceAreaTypeObject() {
            return find(this.serviceAreaList, { isSelected: true });
        }

        _setSelectedAreaList() {
            const { values, count } = this._getSelectedServiceAreaTypeObject();
            this.selectedServiceAreas = values;
            this.totalItems = count;
        }

        _getFilteredServiceAreaList() {
            const { serviceAreaType } = this._getSelectedServiceAreaTypeObject();
            return this.serviceAreaCountyService.getFilteredServiceAreaListByServiceAreaType(this.filterDetails, serviceAreaType);
        }

        _resetPaginationConfigObject() {
            this.itemPerPage = 10;
            this.currentPage = 1;

            this.filterDetails = {
                limit: this.itemPerPage,
                pageId: this.currentPage
            };
        }

        _getServiceAreaTypeList() {
            return this.serviceAreaCountyService.getServiceAreaTypeList();
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/service-area/service-area.component.js